export default __webpack_public_path__ + "static/media/logo.fbf1508c.png";